<template>
    <div>
        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            @submit.prevent="validate"
        >
            <v-alert
                dense
                outlined
                type="success"
                color="teal darken-4"
                elevation="2"
            >
                The member is eligible! You are currently requesting approval for: <br> <b>{{ String(patientCredentials.NAME).toUpperCase() }} - {{ patientCredentials.MEMB_N }}</b>
            </v-alert>
            <MedicalProvidersInformation
                :hosp-items2="data.from.hospItems2"
                :hosp2="data.from.hosp2"
                @setHosp2="setHosp2"
            />
            <RequestingDoctor
                :data="data"
                @resetDoctor="data.from.doc = {doc_name: '', doc_id: ''}"
                @saveNewDoctor="saveNewDoctor"
                @setHosp="setHosp"
            />
            <DiagnosticProcedureRequestForm
                :data="data"
                :trigger-change-color="triggerChangeColor"
                @saveInitialDiagnosis="saveInitialDiagnosis"
                @saveDiagnostics="saveDiagnostics"
                @setReason="setReason"
                @isAmountExceedLimitChange="isAmountExceedLimitFunc"
                @isMemberOfChildbearingAge="isMemberOfChildbearingAge"
                @isMemberPregnant="isMemberPregnant"
                @lmpDate="setLmpDate"
                @isVehicularAccident="isVehicularAccident"
            />
            <MemberEmail
                :data="data"
                :trigger-change-color="triggerChangeColor"
                :patient-credentials="patientCredentials"
                @saveEmail="saveEmail"
            />
            <v-btn
                color="#009688 white--text"
                style="margin: 2% 0 7% 0; background-color: #009688; color: white;"
                :disabled="!valid"
                :loading="isLoading"
                type="submit"
            >
                <v-icon> {{ mdiArrangeSendToBack }}</v-icon>Submit
            </v-btn>
        </v-form>
        <ConfirmSubmit
            :is-confirmed="isConfirmed"
            @submitRequest="submitRequest"
            @closeConfirmSubmit="closeConfirmSubmit"
        />
    </div>
</template>

<script>
import DiagnosticProcedureRequestForm from './DiagnosticProcedureRequestForm.vue'
import MedicalProvidersInformation from './MedicalProvidersInformation.vue'
import RequestingDoctor from './RequestingDoctor.vue'
import MemberEmail from './InputComp/MemberEmail.vue'
import ConfirmSubmit from './ConfirmSubmit.vue'
import { mapActions, mapGetters } from 'vuex'
import { mdiArrangeSendToBack } from '@mdi/js'
export default {
    components: { DiagnosticProcedureRequestForm, MedicalProvidersInformation, RequestingDoctor, MemberEmail, ConfirmSubmit },
    props: ['patientCredentials'],
    data: ()=>({
        mdiArrangeSendToBack,
        isConfirmed: {
            isLoading: false,
            status: false
        },
        triggerChangeColor: 0,
        isSomeDataDiagnostics: true,
        isAmountExceedLimit: false,
        goToOptions: {
            duration: 500,
            offset: 130,
            easing: 'easeInOutCubic'
        },
        data: {
            diagnostics: [],
            diagnosis: {
                choices: [],
                value: null
            },
            fQuestion: {
                isMemberOfChildbearingAge: null,
                isMemberPregnant: null,
                lmpDate: null,
                isVehicularAccident: null
            },
            icdCode: null,
            from: {
                hosp: {
                    hosp_name: '',
                    hosp_msu_code: ''
                },
                hosp2: {
                    hosp_name: '',
                    hosp_msu_code: ''
                },
                hospItems: null,
                hospItems2: null,
                doc: null,
                reason: null
            }
        },
        screen_width: document.documentElement.clientWidth + 9,
        isLoading: false,
        valid: false,
        valid2: false
    }),
    computed: {
        ...mapGetters(['docInfoData', 'getLinkedProvidersData', 'generateApprovalDiagnosticprocedureData'])
    },
    watch: {
        generateApprovalDiagnosticprocedureData(newVal) {
            if (newVal) this.$emit('procedureStatus', newVal.data)
        },
        getLinkedProvidersData(newVal) {
            if (newVal) this.data.from.hospItems = [this.data.from.hosp, ...newVal.data]
            if (newVal) this.data.from.hospItems2 = [this.data.from.hosp, ...newVal.data]
        },
        docInfoData(newVal) {
            if (newVal) {
                const hosp = {
                    hosp_name: newVal.NAME,
                    hosp_msu_code: this.$cookies.get('provider_id')
                }
                this.data.from.hosp = hosp
                this.data.from.hosp2 = hosp
                this.data.from.hospItems = [this.data.from.hosp]
                this.data.from.hospItems2 = [this.data.from.hosp]
            }
        }
    },
    async mounted() {
        if (this.patientCredentials===null)
            this.$emit('reCheckMembEligibility')
        else {
            const PROVIDER_ID = this.$cookies.get('provider_id')
            await this.getProviderInfo({ PROVIDER_ID })
            await this.specializations()
            await this.getDiagnosisList()
            await this.getMembEmail({ MEMB_N: this.patientCredentials.MEMB_N })
            await this.getLinkedProviders({ MSU_C: PROVIDER_ID })
        }
    },
    methods: {
        ...mapActions(['getProviderInfo', 'generateApprovalDiagnosticprocedure', 'getCsrfToken', 'specializations', 'getMembEmail', 'getLinkedProviders', 'getDiagnosisList']),
        isVehicularAccident(newVal) {
            this.data.fQuestion.isVehicularAccident = newVal
        },
        setLmpDate(newVal) {
            this.data.fQuestion.lmpDate = newVal
        },
        isMemberPregnant(newVal) {
            this.data.fQuestion.isMemberPregnant = newVal
        },
        isMemberOfChildbearingAge(newVal) {
            this.data.fQuestion.isMemberOfChildbearingAge = newVal
        },
        isAmountExceedLimitFunc(newVal) {
            this.isAmountExceedLimit = newVal
        },
        setReason(newVal) {
            this.data.from.reason = newVal
        },
        setHosp(newVal) {
            this.data.from.hosp = newVal
        },
        setHosp2(newVal) {
            this.data.from.hosp2 = newVal
        },
        saveDiagnostics(newVal) {
            this.data.diagnostics = newVal
        },
        saveNewDoctor(newVal) {
            this.data.from.doc = newVal
        },
        saveEmail(newVal) {
            this.data.from.email = newVal
        },
        saveInitialDiagnosis(newVal) {
            this.data.diagnosis.value = newVal
        },
        closeConfirmSubmit() {
            this.isLoading = false
            this.isConfirmed.status = false
        },
        async validate () {
            this.triggerChangeColor++
            this.$nextTick(async ()=>{
                this.isSomeDataDiagnostics = this.data.diagnostics.some(item => item.value == true)
                if (this.$refs.form.validate() && this.isSomeDataDiagnostics && !this.isAmountExceedLimit) {
                    this.isLoading  = true
                    this.isConfirmed.status = true
                } else {
                    this.$nextTick(() => {
                        let el = document.querySelector('.v-messages.error--text:first-of-type')
                        if (el)
                            this.$vuetify.goTo(el, this.goToOptions)
                        else {
                            el = document.querySelector('.v-messages')
                            if (el && !this.isSomeDataDiagnostics || el && !this.isAmountExceedLimit)
                                this.$vuetify.goTo(el, this.goToOptions)
                        }
                    })
                }
            })
        },
        async submitRequest () {
            this.isConfirmed.isLoading = true
            let chief_c = this.data.fQuestion.isMemberOfChildbearingAge
                ? `${this.data.from.reason} \nMember Pregnant? ${this.data.fQuestion.isMemberPregnant ? 'YES' : 'NO'} \nLMP: ${this.data.fQuestion.lmpDate}`
                : this.data.from.reason
            chief_c += `\nVEHICULAR ACCIDENT OR MEDICO-LEGAL CASE? ${this.data.fQuestion.isVehicularAccident ? 'YES' : 'NO'}`
            const arg = {
                MEMB_N: this.patientCredentials.MEMB_N,
                TOKEN: this.patientCredentials.TOKEN,
                MEMB_EMAIL: this.data.from.email ? this.data.from.email : null,
                REQUEST: {
                    IS_REFERRAL: true,
                    FR_HOSP: this.data.from.hosp.hosp_msu_code,
                    FR_DOC: this.data.from.doc && this.data.from.doc.doc_id ? parseInt(this.data.from.doc.doc_id) : null,
                    FR_DOC_NAME: this.data.from.doc && this.data.from.doc.doc_name ? this.data.from.doc.doc_name : '',
                    TO_HOSP: this.data.from.hosp2.hosp_msu_code,
                    TO_DOC: null,
                    TO_DOC_NAME: '',
                    CHIEF_C: chief_c,
                    DIAGNOSTICS: this.data.diagnostics.filter(item => item.value == true).map(item => ({ name: item.label, price: Number(item.price) })),
                    DIAGNOSIS: this.data.diagnosis.value.DIAGNOSIS,
                    F_QUESTIONS: this.data.fQuestion.isMemberOfChildbearingAge ? {
                        PREGNANT: this.data.fQuestion.isMemberPregnant,
                        LMP: this.data.fQuestion.lmpDate
                    } : null,
                    ICD_C: this.data.diagnosis.value.ICD_C,
                    MEDICO_LEGAL: this.data.fQuestion.isVehicularAccident
                }
            }
            // console.log('arg: ', arg)
            await this.generateApprovalDiagnosticprocedure(arg)
        }
    }
}
</script>
